import { render } from "./Coordinaten.vue?vue&type=template&id=477fd310&scoped=true"
import script from "./Coordinaten.vue?vue&type=script&lang=js"
export * from "./Coordinaten.vue?vue&type=script&lang=js"

import "./Coordinaten.vue?vue&type=style&index=0&id=477fd310&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-477fd310"

export default script